'use strict';

angular.module('licensure.services')
    .factory('LicenseRules', ['$http', '$q', function ($http, $q) {
        var buildField = function (rule, usedFields, columns) {
            var fields = '';
            var service_entity = false;

            rule.license_rule_field_values.forEach(function (lrfv) {
                var field = '';

                if (!isUndefined(lrfv.license_rule_field.alias)) {
                    field = lrfv.license_rule_field.alias + ' as ' + lrfv.license_rule_field.field_name;
                }
                else {
                    field = lrfv.license_rule_field.table_name + '.' + lrfv.license_rule_field.field_name;
                }

                if (fields.indexOf(field) < 0) {
                    if (fields == '') {
                        fields = field;
                    }
                    else {
                        fields += ',' + field;
                    }
                }

                columns.push({
                    label: lrfv.license_rule_field.name,
                    field: lrfv.license_rule_field.field_name,
                    type: lrfv.license_rule_field.format,
                    revertTimeZone: true
                })

                if (!service_entity && lrfv.license_rule_field.entity.toLowerCase() == 'service'
                    && usedFields.indexOf('services.id as serviceID,services.name as service_name') < 0) {
                    service_entity = true;
                    if (fields == '') {
                        fields = 'services.id as serviceID,services.name as service_name';
                    }
                    else {
                        fields += ',services.id as serviceID,services.name as service_name';
                    }
                    columns.push({
                        label: 'Service Name',
                        field: 'service_name'
                    })
                }
            })

            return fields;
        }

        var buildClause = function (rule) {
            var clauses = '';
            var left = '';
            var dbField = '';
            var operator = '';
            var totalMonths = '';
            var totalYears = '';
            var value = '';
            var right = '';

            rule.license_rule_field_values.sort(sortObjectArray('sort_order')).forEach(function (field) {
                if (field.and_flag) {
                    left = ' and ';
                }
                else {
                    left = ' or ';
                }

                if (field.left_parenthesis != null) {
                    left += field.left_parenthesis;
                }

                if (field.license_rule_field.format.toLowerCase() == 'age' && field.license_rule_field.alias != null && field.license_rule_field.alias != '') {
                    dbField = field.license_rule_field.alias;
                }
                else if (field.license_rule_field.format.toLowerCase() == 'date' && field.value.includes(" date")) {
                    dbField = ' CONVERT(VARCHAR(25),' + field.license_rule_field.table_name + '.' + field.license_rule_field.field_name + ',126) ';
                }
                else if (field.license_rule_field.format.toLowerCase() == 'date' && field.value.toLowerCase().indexOf('month') >= 0) {
                    dbField = ' ' + field.license_rule_field.table_name + '.' + field.license_rule_field.field_name + ' ';
                }
                else if (field.license_rule_field.format.toLowerCase() == 'date' && field.value.toLowerCase().indexOf('year') >= 0) {
                    dbField = ' ' + field.license_rule_field.table_name + '.' + field.license_rule_field.field_name + ' ';
                }
                else if (field.license_rule_field.format.toLowerCase() == 'date' && !isNaN(field.value)) {
                    dbField = " datediff(day,getDate() at time zone 'Central Standard Time', " + field.license_rule_field.table_name + '.' + field.license_rule_field.field_name + ') ';
                }
                else if (field.license_rule_field.table_name.toLowerCase() == 'service_user_position') {
                    dbField = ' V_Service_user_position.PID_' + field.value.replace(/-/g, "_") + ' ';
                }
                else {
                    dbField = ' ' + field.license_rule_field.table_name + '.' + field.license_rule_field.field_name + ' ';
                }

                if (!isUndefined(field.value)) {
                    if (field.operator.toLowerCase() == 'starting' || field.operator.toLowerCase() == 'ending' || field.value.includes(" date")) {
                        dbField = dbField + ' like ';
                    }
                    else {
                        dbField = dbField + ' ' + field.operator + ' ';
                    }
                }
                else {
                    if (field.operator.toLowerCase() == '=') {
                        dbField = '(' + dbField + ' is null ';
                        if (field.license_rule_field.format.toLowerCase() == 'string') {
                            dbField += 'or ' + field.license_rule_field.table_name + '.' + field.license_rule_field.field_name + " = '')";
                        }
                        else {
                            dbField += ')';
                        }
                    }
                    else {
                        dbField = ' ' + dbField + ' is not null ';
                        if (field.license_rule_field.format.toLowerCase() == 'string') {
                            dbField += 'and ' + field.license_rule_field.table_name + '.' + field.license_rule_field.field_name + " <> ''";
                        }
                    }
                }
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth() + 1;
                var yyyy = today.getFullYear();

                if (!isUndefined(field.value) && field.license_rule_field.format.toLowerCase() == 'date') {
                    if (!isNaN(field.value)) {
                        value = field.value;
                    }
                    else if (field.value.includes(" date")) {
                        var date = field.value.substring(6, 10) + '-' + field.value.substring(0, 2) + '-' + field.value.substring(3, 5);
                        value = "'" + date + "%'";
                    }
                    else if (field.value.toLowerCase().indexOf('month') >= 0) {
                        totalMonths = field.value.replace(/ months/g, "");
                        today.setMonth(today.getMonth() + parseInt(totalMonths));
                        mm = today.getMonth() + 1;
                        yyyy = today.getFullYear();
                        //Find out how many days are valid in this month
                        var daysInMonth = new Date(yyyy, mm, 0).getDate();
                        if (daysInMonth < dd) {
                            dd = daysInMonth;
                        }
                        today = mm + '/' + dd + '/' + yyyy;
                        value = "'" + today + "'";
                    }
                    else if (field.value.toLowerCase().indexOf('year') >= 0) {
                        totalYears = field.value.replace(/ years/g, "");
                        yyyy = yyyy + parseInt(totalYears, 10);

                        var daysInMonth = new Date(yyyy, mm, 0).getDate();
                        if (daysInMonth < dd) {
                            dd = daysInMonth;
                        }
                        var newDay = mm + '/' + dd + '/' + yyyy;

                        value = "'" + newDay + "'";
                    }
                    else if (field.value instanceof Date && !isNaN(date.valueOf())) {
                        value = "'" + field.value + "'";
                    }
                    else {
                        value = "''";
                    }
                }
                else if (field.license_rule_field.table_name.toLowerCase() == 'service_user_position') {
                    value = 1;
                }
                else if (!isUndefined(field.value)) {
                    if (field.operator.toLowerCase() == 'like') {
                        value = "'%" + field.value + "%'";
                    }
                    else if (field.operator.toLowerCase() == 'starting') {
                        value = "'" + field.value + "%'";
                    }
                    else if (field.operator.toLowerCase() == 'ending') {
                        value = "'%" + field.value + "'";
                    }
                    else {
                        value = "'" + field.value + "'";
                    }
                }
                else {
                    value = '';
                }

                if (field.right_parenthesis != null) {
                    right = field.right_parenthesis;
                }
                else {
                    right = '';
                }

                clauses += left + dbField + value + right + '\n';
            })

            return clauses;
        }

        return {
            get: function (licenseID) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licenserules', {
                        params: {
                            licenseID: licenseID,
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licenserules/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            // This function will return the fields, criteria, list columns, and number of clauses the rules create.
            build: function (rules) {
                var clauses = '';
                var fields = '';
                var numOfClauses = 3;
                var columns = [];
                rules.forEach(function (rule) {
                    if (rule != null && rule.license_rule_field_values != null && rule.license_rule_field_values.length > 0) {
                        numOfClauses += rule.license_rule_field_values.length;

                        clauses += buildClause(rule);

                        if (fields == '') {
                            fields = buildField(rule, fields, columns);
                        }
                        else {
                            fields += ',' + buildField(rule, fields, columns);
                        }
                    }
                })
                if (numOfClauses > 6) {
                    numOfClauses -= 3;
                }

                return {
                    clauses: clauses,
                    fields: fields,
                    columns: columns,
                    numOfClauses: numOfClauses
                }
            }
        }
    }])
    ;